module.exports = __webpack_public_path__ + "assets/img/desc.4f106f3c.png";